// REQ-FE-029f — `Mix par statut Iopole` chart. Today the contract has
// no `tenants/:id/status-mix` endpoint and the bucket counts are not
// surfaced on TenantKpis. Render an inert placeholder list of the
// expected buckets (per mockup `05-stats.png`) until BE adds the field.
// Logged as REQ-BE follow-up.

const BUCKETS: Array<{ key: string; label: string }> = [
  { key: 'RECEIVED', label: 'RECEIVED' },
  { key: 'PAYMENT_RECEIVED', label: 'PAYMENT_RECEIVED' },
  { key: 'COMPLETED', label: 'COMPLETED' },
  { key: 'DISPUTED', label: 'DISPUTED' },
  { key: 'MADE_AVAILABLE', label: 'MADE_AVAILABLE' },
  { key: 'IN_HAND', label: 'IN_HAND' },
  { key: 'APPROVED', label: 'APPROVED' },
];

export function StatusMixChart() {
  return (
    <div
      className="tenant-stats__mix"
      data-testid="tenant-stats-mix-placeholder"
      aria-label="Mix par statut Iopole — données à venir"
    >
      <ul className="tenant-stats__mix-list">
        {BUCKETS.map((b) => (
          <li
            key={b.key}
            className="tenant-stats__mix-row"
            data-testid={`tenant-stats-mix-${b.key.toLowerCase()}`}
          >
            <span className="tenant-stats__mix-label">{b.label}</span>
            <span className="tenant-stats__mix-bar" aria-hidden="true" />
            <span className="muted tenant-stats__mix-count">—</span>
          </li>
        ))}
      </ul>
      <p className="muted tenant-stats__hint">
        Distribution par statut Iopole disponible après ajout du champ `statusMix` sur `TenantKpis`
        (REQ-BE à venir).
      </p>
    </div>
  );
}
